import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CustomModalService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-new-manage-product-groups',
  templateUrl: './new-manage-product-groups.component.html',
  styleUrls: ['./new-manage-product-groups.component.scss'],
})
export class NewManageProductGroupsComponent {
  @Output() saveManageProductGroupsEvent = new EventEmitter<any>();
  modalLabel: any;

  manageProductGroupAddEditForm!: FormGroup;
  submitted = false;
  isPublicValue: any;
  manageProductGroupData: any;
  activatedRoute: any;
  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public route: ActivatedRoute,
    private cookieService: CookieService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.manageProductGroupData =
      this.modal?.modalService?.config?.initialState?.['manageProductGroupData'];
    this.isPublicValue =
      this.modalLabel === 'Review product group detail'
        ? this.manageProductGroupData.ispublic
        : false;
  }

  ngOnInit(): void {
    this.manageProductGroupAddEditForm = this.formBuilder.group({
      label: [this.manageProductGroupData.label || '', Validators.required],
    });
  }

  onClose() {
    this.modal.close();
  }

  isPublic(event: any) {
    this.isPublicValue = event.target.checked;
  }

  onSave() {
    this.submitted = true;
    if (this.manageProductGroupAddEditForm.controls['label'].value != '' || null) {
      const manageProductGroupAddEditPayload = {
        id: this.manageProductGroupData.id || 0,
        label: this.manageProductGroupAddEditForm.controls['label'].value.trimStart(),
        organizationId: Number(this.cookieService.get('organizationId')),
        ispublic: this.isPublicValue,
      };
      this.saveManageProductGroupsEvent.emit(manageProductGroupAddEditPayload);
    }
  }
}
